import React from 'react';
import { withTheme } from 'styled-components';
import type { DefaultTheme } from 'styled-components';
import { noop } from 'lodash-es';

import BaseButton from './base-button';

interface HollowButtonProps {
  rel?: string;
  target?: string;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  text?: string;
  theme: DefaultTheme;
  disabled?: boolean;
}

const HollowButton = ({
  rel = '',
  target = '_self',
  href,
  onClick = noop,
  text = '',
  theme,
  disabled,
}: HollowButtonProps): React.JSX.Element => (
  <BaseButton
    rel={rel}
    target={target}
    href={href}
    onClick={onClick}
    disabled={disabled}
    defaultStyle={{
      color: theme.colors.selectableLightBg,
      background: theme.colors.white,
      borderColor: theme.colors.selectableLightBg,
    }}
    hoverStyle={{
      color: theme.colors.white,
      background: theme.colors.selectableLightBg,
      borderColor: theme.colors.selectableLightBg,
    }}
  >
    <span>{text}</span>
  </BaseButton>
);

export default withTheme(HollowButton);
